import { render, staticRenderFns } from "./TechnicalDetails.vue?vue&type=template&id=16fa0a00&scoped=true&"
import script from "./TechnicalDetails.vue?vue&type=script&lang=js&"
export * from "./TechnicalDetails.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalDetails.vue?vue&type=style&index=0&id=16fa0a00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fa0a00",
  null
  
)

export default component.exports